import React, { useMemo } from 'react';
import GenericPullConfigListing from '../GenericPullConfigListing'
import MicrosoftDefenderCredentialsForm from './MicrosoftDefenderCredentialsForm'
import MicrosoftDefenderMappingForm from './MicrosoftDefenderMappingForm';
import ContentOverlay from "components/ContentOverlay";
import _ from 'lodash'

export default function MicrosoftDefenderConfigListing(props) {

    const columns = useMemo(() => [
        {
            title: "Microsoft Defender Subscription",
            dataIndex: "subscriptionName",
            width: 120,
        },
        {
            title: "Resource Group",
            dataIndex: "resourceGroupId",
            render: data => {
                if(_.isEmpty(data)) {
                    return 'ALL'
                }
                const renderName = data.split(';').map(item => <p>{_.last(item.split('/'))}</p>)
                return renderName.length === 1 ? renderName  : <ContentOverlay content={renderName} minHeight={40}/>
            },
            width: 120,
        }
    ], [])

    return (
        <GenericPullConfigListing
            {...props}
            toolName={props.name}
            MappingForm={MicrosoftDefenderMappingForm}
            CredentialsForm={MicrosoftDefenderCredentialsForm}
            extraColumns={columns}
            triggerModifyParam={triggerModifyParam}
        />
    )
}
const triggerModifyParam = (record) => {
    return {
        toolConfigId: record.id
    }
};